/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  IGuildStakingAdapter,
  IGuildStakingAdapterInterface,
} from "../IGuildStakingAdapter";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
    ],
    name: "getExtraFeeRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class IGuildStakingAdapter__factory {
  static readonly abi = _abi;
  static createInterface(): IGuildStakingAdapterInterface {
    return new Interface(_abi) as IGuildStakingAdapterInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): IGuildStakingAdapter {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as IGuildStakingAdapter;
  }
}
